module.exports = __webpack_public_path__ + "static/img/selected.1348f967.svg";